import { BlotterDetailsField } from '@/App/Blotter/grids/details/BlotterDetailsField.tsx';
import { PremiumDetailsField } from '@/App/Blotter/grids/option/details/PremiumDetailsField.tsx';
import { StrategyLegFieldSet } from '@/App/Blotter/grids/option/details/StrategyLegFieldSet.tsx';
import { useUserContext } from '@/context/UserContext.tsx';
import { blotterSlice } from '@/store/blotter/slice.ts';
import type { BlotterOptionEntry } from '@/store/blotter/types/BlotterOptionEntry.ts';
import { useAppSelector } from '@/store/hooks.ts';

type Props = {
  entry: BlotterOptionEntry;
};

export const StrategyFieldSet = ({ entry }: Props) => {
  const {
    currentUser: { userType },
  } = useUserContext();

  const legs = useAppSelector((state) => blotterSlice.selectors.getOptionEntriesByStrategyReference(state, entry.id));

  const isInternalSales = userType === 'Internal Sales';
  return (
    <div className="container-fluid">
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Option.details.way"
          labelI18NValues={{ isInternalSales }}
          value={`${entry.way} ${entry.currencyPair}`}
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Option.details.account"
          value={entry.account}
          minWidth="30ch"
          valueDataE2e="blotter-detailsPanel-account"
        />
      </div>
      <div className="row">
        <PremiumDetailsField
          entry={entry}
          labelDataE2e="blotter-detailsPanel-premiumLabel"
          valueDataE2e="blotter-detailsPanel-premiumAmount"
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Option.details.execTime"
          formatting="date"
          value={entry.execTime}
          valueDataE2e="blotter-detailsPanel-tradeDate"
        />
      </div>
      {legs.map((leg, index) => (
        <StrategyLegFieldSet entry={leg} key={leg.id} legIndex={index} />
      ))}
    </div>
  );
};
